import state from "@/store/modules/auth/state";
import actions from "@/store/modules/auth/actions";
import mutations from "@/store/modules/auth/mutations";
import getters from "@/store/modules/auth/getters";


export default {
  state,
  actions,
  mutations,
  getters
}